import styled from 'styled-components';
//
import colors from 'theme/colors';

const { disabledButton, disabledFont, lightBackgroundBase, primary } = colors;

export default styled.button`
  background-color: ${primary};
  border: none;
  border-radius: 3px;
  color: ${lightBackgroundBase};
  font-size: 14px;
  font-weight: 600;
  height: 34px;
  min-width: 93px;
  padding: 0px 16px;
  opacity: 1;
  transition: opacity 0.2s ease;

  :hover {
    opacity: 0.8;
    cursor: pointer;
  }

  :disabled {
    background: ${disabledButton};
    color: ${disabledFont};
    pointer-events: none;
    cursor: default;
  }
`;
